import type { Task } from "@common/types/task";
import type { WorkspaceMember } from "@common/types/workspace";
import {
    getTaskMemberVisibility,
    type MemberVisibilityReason,
} from "./taskClientVisibility";

type HiddenReason = Extract<
    MemberVisibilityReason,
    { visible: false }
>["reason"];

const HIDDEN_REASONS: Record<HiddenReason, string> = {
    org_mismatch: "it belongs to a different organization.",
    has_organization: "they're outside the organization that owns it.",
    missing_entities: "they don't have access to one or more of its entities.",
    not_creator_or_assignee:
        "they're neither the creator nor an allowed viewer.",
};

/** "{name} won't see this task - {why}" when the assignee can't see the task; null when they can. */
export const getAssigneeHiddenTooltip = (
    task: Pick<
        Task,
        "organizationId" | "entityIds" | "createdById" | "assigneeId"
    >,
    assignee: WorkspaceMember,
): string | null => {
    const visibility = getTaskMemberVisibility(task, assignee);
    if (visibility.visible) {
        return null;
    }
    const name = assignee.user.name ?? assignee.user.email;
    return `${name} won't see this task - ${HIDDEN_REASONS[visibility.reason]}`;
};
